import { Button, Input } from '@fullscreendigital/carrefour-dex-fe'
import { FileUpload } from '../../../../../core-ui/FileUpload'
import { ChangeEvent } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { toFormDataPayload } from 'utils/serializers'
import { makeCorePostRequest } from 'utils/api'
import { useMutation } from 'react-query'
import { formatErrorMessage } from 'utils/formatting'
import { useNotification } from 'hooks'
import s from '../../../../commonStyles.modules.scss'
import { useParams } from 'react-router'
import { Grid } from '@mui/material'
import { useOfflineTool } from 'components/core-ui/Offline'
import { AxiosError } from 'axios'
import { useNavigate } from "react-router-dom";

const SupportWrongDestinationDetail = ({ isHistorical }) => {
  const { showNotification } = useNotification()
  const { id } = useParams()
  const offlineTool = useOfflineTool()
  const navigate = useNavigate()

  const onFileUpload = (event: ChangeEvent<HTMLInputElement>) => {
    if (event === null) {
      formik.setFieldValue('file', null)
      return
    }

    const file = event.target.files[0]
    formik.setFieldValue('file', file)
  }

  const updateDetails = async (values: any) => {
    await makeCorePostRequest(
      isHistorical
        ? `/shop-reception/wrongDestinationArchive/form/${id}`
        : `/shop-reception/wrongDestination/form/${id}`,
      values
    )
  }

  const { isLoading, mutate } = useMutation(updateDetails, {
    onSuccess: res => {
      showNotification({
        message: `Modificarile au fost salvate cu succes.`,
        type: 'success'
      })
      formik.resetForm()
      navigate(`/shop-reception/reception/wrongDestinationSupport`)
    },
    onError: (err: any) => {
      if (err?.code === AxiosError.ERR_NETWORK) {
        showNotification({
          message: 'Verificati conexiunea la internet',
          type: 'error'
        })

        // Store offline
        offlineTool.addOwnTask({
          type: `Suporti cu destinatie eronata`,
          data: err.config.data as FormData,
          url: `/shop-reception/wrongDestination/form/${id}`,
          method: 'post'
        })

        return
      }
      showNotification({
        message: `A aparut o eroare. ${formatErrorMessage(err)}`,
        type: 'error'
      })
    }
  })

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      comment: null,
      file: null
    },
    validationSchema: Yup.object().shape({
      comment: Yup.string().required('Campul este obligatoriu.'),
      file: Yup.mixed().required('Trebuie să încărcați o imagine.')
    }),
    onSubmit: async (values: any) => {
      const payload = toFormDataPayload(values)
      mutate(payload)
    }
  })

  return (
    <div className={s.mainContainer}>
      <Grid container display="flex" flexDirection={'column'} pt={2}>
        <Input
          type="textarea"
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            formik.setFieldValue('comment', e.target.value)
          }
          label="Comentariu"
          variant="outlined"
          style={{ width: '100%' }}
          value={formik.values.comment}
          rows={2}
          error={Boolean(formik.errors.comment && formik.touched.comment)}
          helperText={formik.errors.comment as string}
        />
        <Grid item>
          <FileUpload
            value={null}
            fileInputProps={{
              displayImage: ''
            }}
            onChange={onFileUpload}
          />
          {formik.errors.file && formik.touched.file && (
            <div style={{ color: '#AA0D11', marginBottom: '10px', marginLeft: '14px', fontFamily: 'Ubuntu', fontWeight: '400', fontSize: '0.75rem', lineHeight: '1.66' }}>
              {String(formik.errors.file)}
            </div>
          )}
        </Grid>

        <Grid item>
          <Button
            variant="contained"
            type="submit"
            label="Salvează"
            onClick={() => formik.handleSubmit()}
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default SupportWrongDestinationDetail
